import React, { ChangeEvent, FocusEvent } from 'react';
import TextInputProps from './TextInputProps';
import FormInlineError from '../FormInlineError';

const BaseTextInput: React.FC<TextInputProps> = ({
    id,
    label,
    value,
    onChange,
    placeholder,
    onBlur,
    onFocus,
    type = "text",
    className = "",
    errorMessage,
    autoFocus,
    ...props
}) => {
    return (
        <React.Fragment>
            <input
                type={type}
                id={id}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
                autoFocus={autoFocus}
                placeholder={placeholder}
                className={className}
                aria-invalid={!!errorMessage} // Accessibility: marks the input as invalid if there's an error
                {...props}
            />
            {errorMessage && <FormInlineError errorMessage={errorMessage} />}
        </React.Fragment>
    );
};

export default BaseTextInput;
